import React from 'react';

import './Separator.scss';

function Separator() {
  return <div styleName="separator" />;
}

export default React.memo(Separator);
